import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { SimpleModal } from '../../../../../components/simple-modal';
import { FulfillmentProviderSettings } from '../../../../../connection-components/fulfillment-provider-settings';
import { sellerProvidersUpdated } from '../../../../../store/seller/seller.actions';
import messages from './messages';
import styles from './style.module.less';

export const ProviderConnectionModal = ({ sellerFulfillmentProviderId, onClose, onError, show }) => {
  const dispatch = useDispatch();

  const onUpdateSellerData = useCallback(() => {
    dispatch(sellerProvidersUpdated());
  }, [dispatch]);

  return (
    <SimpleModal
      className={styles['settings-modal']}
      headerMessage={messages.providerSettings}
      onClose={onClose}
      shouldIgnoreRootFocus
      show={show}
      size='large'
    >
      <FulfillmentProviderSettings
        onCancel={onClose}
        onError={onError}
        onSave={onUpdateSellerData}
        onUpdateSellerData={onUpdateSellerData}
        sellerFulfillmentProviderId={sellerFulfillmentProviderId}
      />
    </SimpleModal>
  );
};

ProviderConnectionModal.propTypes = {
  sellerFulfillmentProviderId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};
